import { render, staticRenderFns } from "./AcquirerPagSeguroIcon.vue?vue&type=template&id=ff4f7f02"
import script from "./AcquirerPagSeguroIcon.vue?vue&type=script&lang=js"
export * from "./AcquirerPagSeguroIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports